/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import {Page, WKError} from '../components'
import {WalletDetailHeader, WalletDetailList} from '../components/wallet'
import '../css/page/WalletDetailPage.css'


class WalletDetailPage extends React.Component {

    render() {
        const {error} = this.props;
        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }

        return (
            <Page>
                <div className="wallet-detail">

                    <WalletDetailHeader/>

                    <WalletDetailList/>

                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    error: state.error,
}))(WalletDetailPage)



// WEBPACK FOOTER //
// ./src/pages/WalletDetailPage.js